import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "400px",
    height: "min-content",
  },
  content: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing(5),
    alignItems: "center",
  },
  header: {
    fontWeight: 500,
    textAlign: "center",
  },
  loaderBlock: {
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    alignContent: "center",
  },
  errorPaper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: 552,
    height: 320,
    padding: theme.spacing(6, 5),
  },
  successPaper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 552,
    height: 320,
    padding: theme.spacing(6, 5),
  },
  errorElement: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
